import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Subpartners } from '../subpartners/types/index';

const routes: RouteConfig[] = [
  {
    path: '/widgets',
    name: 'widgets',
    component: () => import(/* webpackChunkName: "widgets" */ './views/Widgets.vue'),
    meta: {
      access_roles: RouteRoles[Subpartners.Pages.SUBPARTNERS],
    },
  },
];

export default routes;
